import { computed, type Ref } from "vue";
import type { Editable } from "hoxton-types";

import { useMasterTemplates } from "@/composables/useMasterTemplates";

export function useEditable({ editable }: { editable: Ref<Editable> }) {
    const { masterTemplateLabels } = useMasterTemplates();

    const editableTemplates = computed(() =>
        editable.value.defaultValues.map(defaultValue => defaultValue.masterTemplateId)
    );

    const templateLabels = computed(() => {
        return Object.keys(masterTemplateLabels.value).reduce<Record<string, string>>((acc, masterTemplateId) => {
            if (editableTemplates.value.includes(masterTemplateId)) {
                acc[masterTemplateId] = masterTemplateLabels.value[masterTemplateId]!;
            }

            return acc;
        }, {});
    });

    return {
        editableTemplates,
        templateLabels
    };
}
